import { render, staticRenderFns } from "./LoginGoogleButton.vue?vue&type=template&id=3be81024&scoped=true&"
import script from "./LoginGoogleButton.vue?vue&type=script&lang=ts&"
export * from "./LoginGoogleButton.vue?vue&type=script&lang=ts&"
import style0 from "./LoginGoogleButton.vue?vue&type=style&index=0&id=3be81024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be81024",
  null
  
)

export default component.exports